import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Contract, Payment } from '../../models/contract';
import { ImmobilierService } from '../../services/immobilier.service';
import { AddEditPaymentDialogComponent } from '../add-edit-payment-dialog/add-edit-payment-dialog.component';

@Component({
    selector: 'app-contrat-detail-dialog',
    templateUrl: './contrat-detail-dialog.component.html',
    styleUrls: ['./contrat-detail-dialog.component.css']
})
export class ContratDetailDialogComponent implements OnInit {

    contract: Contract;
    payments: Payment[] = [];
    isPaymentsLoading = false;

    constructor(
        public dialogRef: MatDialogRef<ContratDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private immobilierService: ImmobilierService,
        private dialog: MatDialog
    ) {
        this.contract = data.contract;
    }

    ngOnInit(): void {
        this.loadPayments();
    }

    loadPayments(): void {
        this.isPaymentsLoading = true;
        this.immobilierService.getPaymentsByContract(this.contract.id).subscribe({
            next: (data) => {
                this.payments = data;
                this.isPaymentsLoading = false;
            },
            error: (err) => {
                console.error('Error loading payments', err);
                this.isPaymentsLoading = false;
            }
        });
    }

    openPaymentDialog(payment?: Payment): void {
        const dialogRef = this.dialog.open(AddEditPaymentDialogComponent, {
            width: '600px',
            data: { contractId: this.contract.id, payment: payment, contractType: this.contract.type }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadPayments(); // Reload the payments logic
            }
        });
    }

    deletePayment(paymentId: number): void {
        if (confirm('Voulez-vous vraiment supprimer ce paiement ?')) {
            this.immobilierService.deletePayment(paymentId).subscribe({
                next: () => this.loadPayments(),
                error: (err) => console.error(err)
            });
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    print(): void {
        window.print();
    }

    download(): void {
        if (this.contract.contractDocumentUrl) {
            this.immobilierService.downloadContractFile(this.contract.contractDocumentUrl).subscribe(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = this.contract.contractDocumentUrl!; // Validé par le if
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, error => {
                console.error('Download failed', error);
                // Gérer l'erreur (ex: snackbar)
            });
        } else {
            console.warn('No document URL found for this contract.');
        }
    }
}
